module.exports = __webpack_public_path__ + "img/hp-case-purple-transparent.2a9b9b27.png";